export const GET_PAYMENTS = 'GET_PAYMENTS';
export const GET_PAYMENTS_REQUEST = 'GET_PAYMENTS_REQUEST';
